// extracted by mini-css-extract-plugin
module.exports = {"legal":"legal_legal__4DVy1","legal__wrapper":"legal_legal__wrapper___6zfK"};